import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetWellBornEligibility,
	GetWellBornEligibilityParams,
	GetWellBornEligibilityResponse,
} from 'domain/usecases/private/well-born/get-well-born-eligibility';

export class RemoteGetWellBornEligibility implements GetWellBornEligibility {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetWellBornEligibilityResponse>,
	) {}

	async get({
		signal,
		...params
	}: GetWellBornEligibilityParams): Promise<GetWellBornEligibilityResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
